/* Front pocket personalization — checkout guard.
 *
 * Order #2339 (23 Sep 2026) reached checkout as a $399 bag carrying a full
 * embroidery spec, no artwork file and no service line. The customer had
 * configured personalization and then paid with Apple Pay straight from the
 * product page. Express checkout buttons never fire a form submit event: they
 * read the product form, take its hidden properties[] inputs, and go. The
 * artwork only exists as a Blob in memory and the $99 line is only added by
 * fpm.js's submit handler, so neither happened.
 *
 * This file closes two holes without touching fpm.js:
 *
 *   1. While personalization is switched on, the express buttons are hidden,
 *      so the bypass is not reachable. Plain bags keep one-tap checkout.
 *   2. If personalization is on but unfinished, add-to-cart is blocked with a
 *      message. fpm.js on its own returns early in that case and lets the
 *      native submit add a plain bag, silently.
 *
 * Readiness is read from fpm.js rather than recomputed here: fpm.js writes its
 * [data-fpm-prop] inputs into the form only when its own ready() is true, so
 * their presence IS that signal. Two copies of the rule could disagree; this
 * cannot.
 */
(function () {
  "use strict";

  var CLS = "fpm-personalizing";

  // display:none on the host also hides shadow-DOM children, which is where
  // Shopify renders the actual Apple Pay / Google Pay buttons.
  var CSS =
    "html." + CLS + " .shopify-payment-button," +
    "html." + CLS + " shopify-accelerated-checkout," +
    "html." + CLS + " shopify-accelerated-checkout-cart," +
    "html." + CLS + " [data-shopify=dynamic-checkout-cart]" +
    "{display:none !important}";

  function injectCss() {
    if (document.querySelector("style[data-fpm-guard]")) return;
    var s = document.createElement("style");
    s.setAttribute("data-fpm-guard", "");
    s.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(s);
  }

  function toggleEl() { return document.querySelector("[data-fpm-on]"); }
  function isOn() { var t = toggleEl(); return !!(t && t.checked); }

  function cartForm() { return document.querySelector('form[action*="/cart/add"]'); }

  // fpm.js writes these only when its ready() passes. No prop inputs, not ready.
  function isReady() {
    var f = cartForm();
    return !!(f && f.querySelector("[data-fpm-prop]"));
  }

  function setClass(on) {
    var r = document.documentElement;
    if (r.classList) { r.classList.toggle(CLS, on); return; }
    var c = (" " + r.className + " ").replace(" " + CLS + " ", " ").replace(/\s+/g, " ").trim();
    r.className = on ? (c ? c + " " + CLS : CLS) : c;
  }

  function sync() { setClass(isOn()); }

  function showError(msg) {
    var e = document.querySelector("[data-fpm-error]");
    if (!e) { if (msg) window.alert(msg); return; }
    e.textContent = msg;
    if (msg) e.removeAttribute("hidden"); else e.setAttribute("hidden", "");
  }

  // Capture on window runs ahead of fpm.js's own capture listener on document,
  // so an unfinished order is stopped before anything else sees the event.
  window.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf("/cart/add") === -1) return;
    if (!isOn() || isReady()) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    showError("Add the text you want stitched or upload your logo before adding to cart — or switch personalization off to order a plain bag.");
    var panel = document.querySelector("[data-fpm-panel]") || toggleEl();
    if (panel && panel.scrollIntoView) {
      try { panel.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (_) {}
    }
  }, true);

  document.addEventListener("change", function (e) {
    if (e.target && e.target.hasAttribute && e.target.hasAttribute("data-fpm-on")) sync();
  }, true);

  injectCss();
  sync();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { injectCss(); sync(); });
  }

  // Shopify injects the wallet buttons after first paint, and the theme
  // re-renders the buy-buttons block on variant change. A cheap poll keeps the
  // gate correct through both without wiring into theme internals.
  var ticks = 0;
  var t = setInterval(function () {
    sync();
    if (++ticks > 60) clearInterval(t);
  }, 500);
  document.addEventListener("shopify:section:load", sync);
})();
